import ReactGA from 'react-ga4';

export const trackButtonClick = (label, location) => {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: `${label} - ${location}`
  });
};